export default "__VITE_ASSET__7bef00c4__"